class OpenSupportChatHandler {
  static async apply() {
    const a = document.createElement("a")
    a.href = "javascript:window.HubSpotConversations.widget.open()"
    a.click()
    a.remove()
  }
}

export default OpenSupportChatHandler
